'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _personalDetails = require('redux/modules/personalDetails');

var personalDetails = _interopRequireWildcard(_personalDetails);

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

require('semantic-ui-css/semantic.min.css');

var _semanticUiReact = require('semantic-ui-react');

var _saveUserData = require('redux/modules/saveUserData');

var _reactDatez = require('react-datez');

require('react-datez/dist/css/react-datez.css');

var _reactGeosuggest = require('react-geosuggest');

var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);

var _components = require('components');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

require('./geosuggest.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleLine = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    content_template_data: state.templateData.content_template_data,
    personal_info: state.templateData.personal_info,
    info_block: state.templateData.info_block,
    design_order: state.templateData.design_order,
    template_data: state.templateData,
    inter_section_margin: state.templateData.inter_section_margin,
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    header_font: state.templateData.header_font,
    body_font: state.templateData.body_font,
    design_template_name: state.templateData.design_template_name,
    content_template_name: state.templateData.content_template_name,
    ReactGA: state.company.ReactGA,
    resume_review_id: state.templateData.resume_review_id
  };
}, {
  updateInfo: templateData.updateField,
  updatePersonalDetails: templateData.updatePersonalDetails,
  saveUserData: _saveUserData.save
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SingleLine, _Component);

  function SingleLine(props) {
    (0, _classCallCheck3.default)(this, SingleLine);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SingleLine.__proto__ || (0, _getPrototypeOf2.default)(SingleLine)).call(this, props));

    var _this$props = _this.props,
        type = _this$props.type,
        placeholder = _this$props.placeholder,
        defaultValue = _this$props.defaultValue;

    _this.state = {
      value: defaultValue ? defaultValue : '',
      dateInput: '',
      accepted: [],
      rejected: []
    };
    return _this;
  }

  (0, _createClass3.default)(SingleLine, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps != this.props) {
        // Changing logic to not update states using props instead change them
        // realtime this would increase user performance, do need to take care that the data
        // is being updated nicely or not
        // console.log('triggered');
        // if(this.props.data_parent === 'professional'){
        //   const data = nextProps.professional_info[nextProps.data_id][nextProps.data_type];
        //   this.setState({value: data});
        // }
        // if(this.props.data_parent === 'miscellaneous'){
        //   const data = nextProps.miscellaneous_info[nextProps.data_id][nextProps.data_type];
        //   this.setState({value: data});
        // }

        if (this.props.data_parent === 'personal') {
          var data = nextProps.personal_info[nextProps.data_type];
          var elementType = this.props.data_type;
          this.setState({ value: data });
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var data;
      if (this.props.data_parent === 'personal') {
        data = this.props.personal_info[this.props.data_type];
      } else {
        var info_block = this.props.info_block[this.props.data_parent];
        data = info_block[this.props.data_id][this.props.data_type];
      }
      this.setState({ value: data });
    }
  }, {
    key: 'onFocus',
    value: function onFocus(event, type) {
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Edit: ' + type,
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var newValue;
      if (event.target) {
        // Adding these change to accomodate new types of fields
        // Only Textarea get to here
        newValue = event.target.value;
      } else {
        if (this.props.data_type === 'location') {
          // Only location field gets to here
          if (event.gmaps) {
            newValue = event.gmaps.address_components[0].short_name + ', ' + event.gmaps.address_components[event.gmaps.address_components.length - 1].short_name;
            this._geoSuggest.update(newValue);
          } else {
            // This is to allow manually setting of Location
            newValue = event;
          }
        } else {
          // only date pickers get to here.
          newValue = event;
        }
      }
      this.setState({ value: newValue });
      var elementID = this.props.data_id;
      var elementParent = this.props.data_parent;
      var elementType = this.props.data_type;
      // if(elementParent === 'professional'){
      //   this.props.updateProfessionalDetails(newValue, elementID, elementType)
      // }
      // if(elementParent === 'miscellaneous'){
      //   this.props.updateMiscellaneousInfo(newValue, elementID, elementType)
      // }

      if (elementParent === 'personal') {
        this.props.updatePersonalDetails(newValue, elementType);
        // TODO: This has to be updated when we change the Reducer.
        // DONE: Need to test.
        // this.props.updateMiscellaneousInfo(value.value, elementID, elementType)
      } else {
        this.props.updateInfo(newValue, elementID, elementType, elementParent);
      }
      // this.setState({value: event.target.value});
    }
  }, {
    key: 'saveState',
    value: function saveState() {
      var object = {};
      object['personal'] = this.props.personal_info;
      object['info'] = this.props.info_block;
      object['design_template_id'] = this.props.template_data.design_template_id;
      object['content_template_id'] = this.props.template_data.content_template_id;
      object['design_order'] = this.props.design_order.toString();
      object['inter_section_margin'] = this.props.template_data.inter_section_margin;
      object['primary_color'] = this.props.template_data.primary_color;
      object['secondary_color'] = this.props.template_data.secondary_color;
      object['header_font'] = this.props.header_font;
      object['body_font'] = this.props.body_font;
      object['resume_name'] = this.props.template_data.resume_name;
      object['resume_review_id'] = this.props.resume_review_id;

      // Converting back to string so that consistency is maintained on data coming from server
      this.props.saveUserData(object);
    }
  }, {
    key: 'onDrop',
    value: function onDrop(accepted, rejected) {
      var _this2 = this;

      accepted.forEach(function (file) {
        var reader = new FileReader();
        reader.onload = function () {
          var fileAsBinaryString = reader.result;
          // do whatever you want with the file content
          _this2.onChange(fileAsBinaryString);
        };
        reader.onabort = function () {
          return console.log('file reading was aborted');
        };
        reader.onerror = function () {
          return console.log('file reading has failed');
        };

        reader.readAsDataURL(file);
      });
      this.setState({ accepted: accepted, rejected: rejected });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var elementType = this.props.data_type;
      var elementParent = this.props.data_parent;
      var _props = this.props,
          style = _props.style,
          type = _props.type,
          placeholder = _props.placeholder,
          textAreaColorClass = _props.textAreaColorClass; // eslint-disable-line no-shadow

      var styles = require('./SingleLine.scss');
      var headingMargin = {
        marginTop: this.props.inter_section_margin,
        marginBottom: this.props.inter_section_margin
      };
      var styleit = {};
      if (style) {
        styleit = JSON.parse(style.replace(/'/g, '"'));
      }
      if (elementType === 'location') {
        return _react2.default.createElement(_reactGeosuggest2.default, {
          ref: function ref(el) {
            return _this3._geoSuggest = el;
          },
          placeholder: 'Search Location',
          className: styles.textarea + ' ' + textAreaColorClass,
          types: ['(cities)'],
          onFocus: function onFocus(event) {
            return _this3.onFocus(event, elementType);
          },
          onBlur: function onBlur() {
            return _this3.saveState();
          },
          onChange: function onChange(event) {
            return _this3.onChange(event);
          },
          onSuggestSelect: function onSuggestSelect(event) {
            _this3.onChange(event);
          },
          value: this.state.value,
          initialValue: this.state.value
        });
      }
      if (elementType === 'date_from' || elementType === 'date_to') {
        return _react2.default.createElement(_reactDatez.ReactDatez, (0, _defineProperty3.default)({
          className: styles.textarea + ' ' + textAreaColorClass,
          handleChange: function handleChange(event) {
            return _this3.onChange(event);
          },
          placeholder: placeholder ? placeholder : 'Enter Text',
          format: "MMM 'YY",
          allowPast: true,
          value: this.state.value,
          onBlur: function onBlur() {
            return _this3.saveState();
          },
          onFocus: function onFocus(event) {
            return _this3.onFocus(event, elementType);
          },
          style: styleit
        }, 'className', styles.textarea));
      }
      if (elementType === 'image') {
        return _react2.default.createElement(
          'div',
          { className: 'imageWrapper' },
          _react2.default.createElement(
            _reactDropzone2.default,
            {
              multiple: false,
              accept: 'image/jpeg, image/png',
              maxSize: 200000,
              onFocus: function onFocus(event) {
                return _this3.onFocus(event, elementType);
              },
              onDrop: function onDrop(accepted, rejected) {
                return _this3.onDrop(accepted, rejected);
              }
            },
            this.state.value && _react2.default.createElement('img', { src: this.state.value }),
            !this.state.accepted && _react2.default.createElement(
              'p',
              null,
              'Only *.jpeg and *.png images will be accepted'
            ),
            this.state.accepted.map(function (f) {
              return _react2.default.createElement('img', { src: f.preview });
            }),
            this.state.rejected.map(function (f) {
              if (f.size > 200000) {
                return _react2.default.createElement(
                  'li',
                  { key: f.name },
                  'Upload an image less than 200 kb'
                );
              } else {
                return _react2.default.createElement(
                  'li',
                  { key: f.name },
                  'Rejected ',
                  f.name,
                  ' as it is not png or jpeg'
                );
              }
            })
          )
        );
      } else {
        return _react2.default.createElement(_semanticUiReact.TextArea, {
          className: styles.textarea + ' ' + textAreaColorClass,
          style: styleit,
          autoHeight: true,
          rows: 1,
          type: 'text',
          placeholder: placeholder ? placeholder : 'Enter Text',
          value: this.state.value,
          onFocus: function onFocus(event) {
            return _this3.onFocus(event, elementType + '-' + elementParent);
          },
          onChange: function onChange(event) {
            return _this3.onChange(event);
          },
          onBlur: function onBlur() {
            return _this3.saveState();
          }
        });
      }
    }
  }]);
  return SingleLine;
}(_react.Component), _class2.propTypes = {
  type: _react.PropTypes.string,
  placeholder: _react.PropTypes.string,
  defaultValue: _react.PropTypes.string
}, _temp)) || _class);
exports.default = SingleLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleLine/SingleLine.js
// module id = 1746
// module chunks = 0